module.exports = __webpack_public_path__ + "static/media/coin.695dee71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/bonus/coin.svg
// module id = 31
// module chunks = 0